import { fromJS } from 'immutable';
import * as constants from '../constants';
import { equals } from 'ramda';

const initialState = fromJS({
  partnersToSendTo: [],
  existingConnections: [],
  filteredConnections: [],
  selectedExistingPartners: [], // holding for existing partners
  sendToPartners: false,
  addPartnersMethod: '',
  showSelectMethod: false,
  showReview: false,
  showAddIndividuallyDialog: false,
  showSelectFromPartnersDialog: false,
  showUploadFileDialog: false,
  showEmailImportDialog: false,
  individualCompanyName: '',
  individualEmail: '',
  searchField: '',
  sendingMM: false,
});

export default function partnerReducer(state = initialState, { type, payload }) {
  switch (type) {
    case constants.GOT_PARTNERS:
      return state.set('existingConnections', fromJS(payload));
    case constants.UPDATE_MM_PARTNER_PROP:
      return state.merge(fromJS(payload));
    case constants.CHECK_CONNECTION:
      if (equals(payload.checkType, 'checkOne')) return state.update('selectedExistingPartners', selected => selected.push(fromJS(payload.partner)));
      return state.set('selectedExistingPartners', equals(state.get('filteredConnections').size, 0) ? state.get('existingConnections') : state.get('filteredConnections'));
    case constants.UNCHECK_CONNECTION:
      if (equals(payload.checkType, 'uncheckOne')) return state.update('selectedExistingPartners', selected => selected.filterNot(equals(fromJS(payload.partner))));
      return state.set('selectedExistingPartners', fromJS([]));
    case constants.SENDING_MARKETING_MATERIALS:
      return state.set('sendingMM', true);
    case constants.SENT_MARKETING_MATERIALS:
      return state.set('sendingMM', false);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/marketing-materials/reducers/select-partner-reducer.js